import Megarubigram from './Megarubigram';

export default Megarubigram;